import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../../../../components/home_page/Footer';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { voucherTypeDefaultList, numberSeriesList, numberSeriesCreate, voucherTypeUpdate, voucherTypeSingleData }
  from '../../../../../redux/actions/action-creator';
import Form from '../../../../../components/Form/Form';
import FormData from 'form-data';
import MasterListFooter from '../../../../../components/Footer/Master_Footer/MasterListFooter';
import { toast } from 'react-toastify';
const initialState = {
  voucher_type_name: '',
  alise_name: '',
  select_type_of_voucher: '',
  select_type_of_voucher_id: '',
  abbreviation: '',
  active_this_voucher_type: 'Yes',
  define_multiple_numbering_series_for_vouchers: 'No',
  show_unsed_vch_nos_in_transaction_for_retain_original_voucher_no_behaviour: 'Yes',
  method_of_voucher_number: '',
  use_effective_dates_for_vouchers: 'No',
  allow_zero_valued_transactions: 'No',
  make_this_voucher_type_as_optional_by_default: 'No',
  allow_narration_in_voucher: 'Yes',
  provide_narration_for_each_ledger_in_voucher: 'No',
  print_voucher_after_saving: 'No',
  enable_default_accounting_allocations: '',
  set_alter_default_accounting_entries: '',
  track_additional_costs_for_purchases: '',
  default_jurisdiction: '',
  default_title_to_print: '',
  print_formal_receipt_after_saving: '',
  use_for_pos_invoicing: '',
  message_to_print_1: '',
  message_to_print_2: '',
  default_bank: '',
  set_alter_declaration: '',
  use_a_manufacturing_journal: '',
}
const VouchersTypeView = ({ data_to_view, title, closeModal_sec }) => {
  //const { id } = useParams();
  const dispatch = useDispatch();
  const [load, setLoad] = useState(false)
  const [filteredData, setFilteredData] = useState([]);
  const [isVoucherTypeNameEntered, setIsVoucherTypeNameEntered] = useState(false);
  const [isVoucherTypeNameExists, setIsVoucherTypeNameExists] = useState('');
  const [state, setState] = useState(initialState);
  const voucher_type_default_data = useSelector(state => state.common.voucher_type_default_data);
  const { userData = null } = useSelector(state => state.auth);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const voucherTypeNameInputRef = useRef(null)
  const [showList, setShowList] = useState(false);
  const [contra, setcontra] = useState(false);
  const [creditNote, setcreditNote] = useState(false);
  const [debitNote, setdebitNote] = useState(false);
  const [journal, setjournal] = useState(false);
  const [payment, setpayment] = useState(false);
  const [purchase, setpurchase] = useState(false);
  const [receipt, setreceipt] = useState(false);
  const [sales, setsales] = useState(false);
  const [deliveryNote, setdeliveryNote] = useState(false);
  const [receiptNote, setreceiptNote] = useState(false);
  const [physicalStock, setphysicalStock] = useState(false);
  const [stockJournal, setstockJournal] = useState(false);
  const [purchaseOrder, setpurchaseOrder] = useState(false);
  const [salesOrder, setsalesOrder] = useState(false);
  const [defineNumberModal, setDefineNumberModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState(0);
  const [data, setData] = useState(initialState);
  useEffect(() => {
    setLoad(true);
    dispatch(voucherTypeSingleData(data_to_view)).then((response) => {
      if (response.status) {
        setData({
          voucher_type_name: response?.data?.voucher_type_name,
          alise_name: response?.data?.alias_name,
          select_type_of_voucher: response?.data?.select_type_of_voucher,
          select_type_of_voucher_id: response?.data?.voucher_type_id,
          abbreviation: response?.data?.abbreviation,
          active_this_voucher_type: response?.data?.activate_this_voucher_type === 1 ? 'Yes' : 'No',
          define_multiple_numbering_series_for_vouchers: response?.data?.define_multiple_numbering_series_for_vouchers,
          show_unsed_vch_nos_in_transaction_for_retain_original_voucher_no_behaviour: response?.data?.show_unsed_vch_nos_in_transaction_for_retian_original_vch_no_beh,
          // method_of_voucher_number: response?.data?.voucher_type_name,
          use_effective_dates_for_vouchers: response?.data?.use_effective_date_for_vouchers,
          allow_zero_valued_transactions: response?.data?.allow_zero_valued_transactions,
          make_this_voucher_type_as_optional_by_default: response?.data?.make_this_voucher_type_as_optional_by_default,
          allow_narration_in_voucher: response?.data?.allow_narration_in_voucher,
          provide_narration_for_each_ledger_in_voucher: response?.data?.provide_narrations_for_each_ledger_in_voucher,
          print_voucher_after_saving: response?.data?.printing_voucher_after_saving,
          enable_default_accounting_allocations: response?.data?.enable_default_accounting_allocations,
          set_alter_default_accounting_entries: response?.data?.set_alter_default_accounting_entries,
          track_additional_costs_for_purchases: response?.data?.track_additional_costs_for_purchases,
          default_jurisdiction: response?.data?.default_jurisdiction,
          default_title_to_print: response?.data?.default_title_to_print,
          print_formal_receipt_after_saving: response?.data?.voucher_type_name,
          use_for_pos_invoicing: response?.data?.use_for_pos_invoicing,
          message_to_print_1: response?.data?.message_to_print_1,
          message_to_print_2: response?.data?.message_to_print_2,
          default_bank: response?.data?.default_bank,
          set_alter_declaration: response?.data?.set_alter_declaration,
          use_a_manufacturing_journal: response?.data?.voucher_type_name,
        })
        setLoad(false)
      }
      else {
        toast.warn(response?.message || 'Fail !', {
          position: toast.POSITION.TOP_CENTER
        });
      }
    }).catch(error => {
      console.log(error)
      toast.error(error?.message || ' Failed!', {
        position: toast.POSITION.TOP_CENTER
      });
    })
  }, [])

  const {
    voucher_type_name,
    alise_name,
    select_type_of_voucher,
    abbreviation,
    active_this_voucher_type,
    define_multiple_numbering_series_for_vouchers,
    show_unsed_vch_nos_in_transaction_for_retain_original_voucher_no_behaviour,
    method_of_voucher_number,
    use_effective_dates_for_vouchers,
    allow_zero_valued_transactions,
    make_this_voucher_type_as_optional_by_default,
    allow_narration_in_voucher,
    provide_narration_for_each_ledger_in_voucher, print_voucher_after_saving,
    enable_default_accounting_allocations,
    set_alter_default_accounting_entries,
    track_additional_costs_for_purchases,
    default_jurisdiction, default_title_to_print,
    print_formal_receipt_after_saving,
    use_for_pos_invoicing, message_to_print_1, message_to_print_2, default_bank, set_alter_declaration,
    use_a_manufacturing_journal,
  } = state;

  return (
    <Form
      title='Vouchers Type View'
      loading={load}
      col='col-7'
      Footer={MasterListFooter}
    >
      <div className='row p-0 ps-2 m-0 mb-1'>
            <div
              className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
            >
              Name
            </div>
            <div 
              className="col-1 font_size p-0 m-0 text-center fw-bold"
            >
            :
            </div>
            <div
              className={`col-9 font_size p-0 m-0 ps-1 text-start`}
            >
              {data?.voucher_type_name}
            </div>
            <div className='border'></div>
            <div
              className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
            >
              Alise 
            </div>
            <div 
              className="col-1 font_size p-0 m-0 text-center fw-bold"
            >
            :
            </div>
            <div
              className={`col-9 font_size p-0 m-0 ps-1 text-start`}
            >
              {data?.alise_name}
            </div>
            <div className='border'></div>
            <div
              className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
            >
              Under
            </div>
            <div 
              className="col-1 font_size p-0 m-0 text-center fw-bold"
            >
            :
            </div>
            <div
              className={`col-9 font_size p-0 m-0 ps-1 text-start`}
            >
              {data?.select_type_of_voucher}
            </div>
            <div className='border'></div>
            <div
              className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
            >
              Abbreviation
            </div>
            <div 
              className="col-1 font_size p-0 m-0 text-center fw-bold"
            >
            :
            </div>
            <div
              className={`col-9 font_size p-0 m-0 ps-1 text-start`}
            >
              {data?.abbreviation}
            </div>
        </div>
    </Form>
  )
}

export default VouchersTypeView;